import { render, staticRenderFns } from "./OnInspectResolution.vue?vue&type=template&id=0b2f4eae"
import script from "./OnInspectResolution.vue?vue&type=script&lang=js"
export * from "./OnInspectResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports